import { Controller } from 'react-hook-form';
import { prop } from 'ramda';
import { Message, TextArea } from '@fasstech/middle-design-system';
import hasError from './helpers/hasError';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import { useEffect } from 'react';

const ControlledTextArea = ({
  hideLabel = false,
  rules = {},
  name,
  label,
  form,
  formTrigger = () => {},
  formWatch = null,
  placeholder = label,
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  useEffect(() => {
    formTrigger();
  }, [formWatch]);

  const $label = prop('required', rules) ? `${label} *` : label;

  return (
    <div className={'w-full'}>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => {
          return (
            <TextArea
              label={!hideLabel ? $label : ''}
              withIndicator
              error={getErrorMessage(form.formState.errors, name)}
              {...props}
              {...props.field}
              {...extraProps}
              placeholder={placeholder}
              className={hasError(form.formState.errors, name) ? 'border-red-500' : ''}
            />
          );
        }}
      />
      <Message variant="error" label={getErrorMessage(form.formState.errors, name)} />
    </div>
  );
};

export default ControlledTextArea;
